<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">{{pageTitle}}</div>
                    <button type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                </div>
                <!--Forms-->
                <form>
                    <div class="forms-container">
                        <div class="row no-margin">
                            <!-- Name -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Name :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input @input="nameErorr = ''" type="text" maxlength="190" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                    <div class="help is-danger">{{nameErorr}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <!-- Date -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Date :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <date-picker @input="dateError = ''" placeholder="MM/DD/YYYY" id="date" name="date" v-model="date" :config="options" aria-describedby="basic-addon1"></date-picker>
                                    <div class="help is-danger">{{dateError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <!-- Location -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Location :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="location" name="location"
                                        label="name" placeholder="Select Location"
                                        :options="locationArr" :clearable=false>
                                    </v-select>
                                    <div class="help is-danger">{{locationError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <!-- Email -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Email :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input @input="emailError = ''" type="text" maxlength="190" class="form-control" v-model="email" id="email" placeholder="Enter Email" name="email">
                                    <div class="help is-danger">{{emailError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <!-- Phone -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Phone :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input @input="phoneNumberError = ''" type="text" maxlength="190" class="form-control" v-model="phoneNumber" id="phoneNumber" placeholder="Enter Phone" name="phoneNumber">
                                    <div class="help is-danger">{{phoneNumberError}}</div>
                                </div>
                            </div>
                            <!-- WHAT PROJECT / PROCESS IMPROVEMENT ARE YOU PROPOSING? -->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">What Project / Process Improvement are you Proposing? :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <textarea @input="describeCurrentProcessAndProblemError = ''" maxlength="65534" type="text" class="form-control" v-model="describeCurrentProcessAndProblem" id="describeCurrentProcessAndProblemError" name="describeCurrentProcessAndProblemError"></textarea>
                                    (DESCRIBE CURRENT PROCESS AND PROBLEM)
                                    <!-- <div class="help is-danger">{{describeCurrentProcessAndProblemError}}</div>
                                    <div class="requiredstar">*</div> -->
                                </div>
                            </div>
                            <!-- HOW WILL IT BENEFIT THE BUSINESS? -->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">How will it Benefit the Business? :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <textarea @input="howWillItBenefitTheBusinessError = ''" maxlength="65534" type="text" class="form-control" v-model="howWillItBenefitTheBusiness" id="howWillItBenefitTheBusiness" name="howWillItBenefitTheBusiness"></textarea>
                                    <!-- <div class="help is-danger">{{howWillItBenefitTheBusinessError}}</div>
                                    <div class="requiredstar">*</div> -->
                                </div>
                            </div>

                            <div class="clearfix"></div>
                            <div class="mr-17 pb-12 float-l">
                                <button type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                                <button v-if="edit_id == 0" type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="AddUpdateContinuousImprovementSuggestions('save_and_continue')"><span id="saveAndContinueAttachment">Save And Continue</span></button>
                                <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="AddUpdateContinuousImprovementSuggestions('save')"><span id="createAttachment">Save</span></button>
                            </div>
                        </div>
                    </div>
                </form>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPGUZZLE} from '../../../http-common.js';
    import {commonMixins} from '../../../mixins/commonMixins';
    import EventBus from "../../../components/event-bus";
    var self;
    Vue.component('v-select', vSelect)
    Vue.component("app-footer", Footer);
    export default {
        name: 'AddUpdateContinuousImprovementSuggestions',
        mixins: [commonMixins],
        data() {
            return {
                //user_role: 0,
                pageTitle: 'Add Continuous Improvement Suggestions',
                edit_id: 0,
                name: "",
                nameErorr: "",
                options: {
                    format: 'MM/DD/YYYY',
                },
                date: new Date(),
                dateError: "",
                location: "",
                locationArr: [],
                locationError: "",
                email: "",
                emailError: "",
                phoneNumber: "",
                phoneNumberError: "",
                describeCurrentProcessAndProblem: "",
                describeCurrentProcessAndProblemError: "",
                howWillItBenefitTheBusiness: "",
                howWillItBenefitTheBusinessError: "",
                loginUserRoleId: 1,
            }
        },
        watch: {
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.menuActive("ContinuousImprovementSuggestionsForm");
            self.showLoader();

            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
            }

            self.loadLocation();
            this.$nextTick(function () {
                if (typeof(self.$route.params.id)  != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                    self.edit_id = self.$route.params.id;
                    self.pageTitle = 'Edit Continuous Improvement Suggestions';
                    self.getContinuousImprovementSuggestionsById();
                    $("#addAndContinueLocationBtn").hide();
                    $("#createAttachment").html("Update");
                } else {
                    self.hideLoader();
                }
            });
        },
        methods: {
            buttonBack() {
                self.$router.push('/continuous/improvement/suggestions/list');
            },
            loadLocation: function() {
                var config = {
                    params: {
                        slug: "velocity-vehicle-group",
                        department_id: process.env.VUE_APP_CIC_DEPARTMENT_ID // SSO Dept(5) = CIC
                    }
                };
                self.showLoader();
                HTTPGUZZLE.get("/getdepartmentlocationswohtml", config)
                        .then(function (response) {
                            self.locationArr = response.data.locations;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            getContinuousImprovementSuggestionsById() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {
                        id: self.edit_id
                    }
                };
                self.showLoader();
                HTTP.get("/continuous/improvement/suggestions/get", config)
                        .then(function (response) {
                            self.name = response.data.content.name;
                            self.date = response.data.content.date;
                            self.email = response.data.content.email;
                            self.phoneNumber = response.data.content.phone_number;
                            self.describeCurrentProcessAndProblem = response.data.content.describe_current_process_and_problem;
                            self.howWillItBenefitTheBusiness = response.data.content.how_will_it_benefit_the_business;
                            var objLoc = {
                                "name": response.data.content.location_name,
                                "id": response.data.content.location_id,
                                "position": {
                                    "lat": 0.00,
                                    "lng": 0.00
                                },
                                "is_buswest": false,
                                "manager_email": response.data.content.manager_email,
                                "manager_name": response.data.content.manager_name
                            };
                            self.location = objLoc;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            checkForm: function () {
                var checked = true;
                self.nameErorr = "";
                self.dateError = "";
                self.locationError = "";
                self.emailError = "";
                self.phoneNumberError = "";
                self.describeCurrentProcessAndProblemError = "";
                self.howWillItBenefitTheBusinessError = "";

                if (!self.name) {
                    self.nameErorr = "Please enter name";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.date) {
                    self.dateError = "Select Date";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.location == null || !self.location.id) {
                    self.locationError = "select Location";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.email) {
                    self.emailError = "Please enter email";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.email && !self.validEmail(self.email)) {
                    self.emailError = "Please Enter Valid Email";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.phoneNumber && !self.validContactNumber(self.phoneNumber)) {
                    self.phoneNumberError = "Please Enter Valid Phone";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.phoneNumber && !self.checkContactNoLength(self.phoneNumber)) {
                    self.phoneNumberError = "Max Length is 13";
                    if (checked) {
                        checked = false;
                    }
                }
                /* if (!self.describeCurrentProcessAndProblem) {
                    self.describeCurrentProcessAndProblemError = "Please enter describe Current Process And Problem";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.howWillItBenefitTheBusiness) {
                    self.howWillItBenefitTheBusinessError = "Please enter how will it Benefit the Business";
                    if (checked) {
                        checked = false;
                    }
                } */
                return checked;
            },
            AddUpdateContinuousImprovementSuggestions(flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                        };
                        var fields = {
                            id: self.edit_id,
                            manager_email: self.location.manager_email,
                            manager_name: self.location.manager_name,
                            name: self.name,
                            date: self.date,
                            location_id: self.location.id,
                            location_name: self.location.name,
                            email: self.email,
                            phone_number: self.phoneNumber,
                            describe_current_process_and_problem: self.describeCurrentProcessAndProblem,
                            how_will_it_benefit_the_business: self.howWillItBenefitTheBusiness,
                        };
                        self.showLoader();
                        HTTP.post("/continuous/improvement/suggestions/add/update", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    if (flag == 'save') {
                                        self.buttonBack();
                                    } else {                                        
                                        self.name = '';
                                        self.date = new Date();
                                        self.location = '';
                                        self.email = '';
                                        self.phoneNumber = '';
                                        self.describeCurrentProcessAndProblem = '';
                                        self.howWillItBenefitTheBusiness = '';
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
        }
    };
</script>